import ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { Observable } from "rxjs";
import { catchError, finalize, map, tap } from "rxjs/operators";
import { create } from "superstruct";
import { singleton } from "tsyringe";

import { LoggerInterface } from "@interfaces/LoggerInterface";

import InstagramGalleryEntity from "../../entities/InstagramGalleryEntity";
import InstagramGallerySchema from "../../schemas/InstagramGallerySchema";
import InstagramGalleriesStore from "../../stores/InstagramGalleryStore";
import InstagraGalleryServiceInterface from "./InstagramGalleryServiceInterface";

@singleton()
class instagramGalleryService implements InstagraGalleryServiceInterface {
    constructor(
        private instagramGalleriesStore: InstagramGalleriesStore,
        private readonly apiClient: ApiClientInterface,
        private readonly logger: LoggerInterface
    ) {}
    getGallery(id?: number): Observable<InstagramGalleryEntity> {
        this.logger.debug(
            "InstagramGalleriesService.getGalleryById is started",
            {
                id,
            }
        );
        this.instagramGalleriesStore.setLoading(true);
        return this.apiClient
            .get({
                url: "/instagram/getGallery",
                responseType: "json",
                queryParams: id
                    ? {
                          id,
                      }
                    : undefined,
            })
            .pipe(
                finalize(() => {
                    this.instagramGalleriesStore.setLoading(false);
                }),
                map((v) => create(v.body, InstagramGallerySchema)),
                catchError((error: unknown) => {
                    this.logger.debug(
                        "InstagramGalleriesService.getGalleryById is errored",
                        {
                            id,
                        }
                    );
                    this.instagramGalleriesStore.setError(true);
                    throw error;
                }),
                tap((v) => {
                    this.logger.debug(
                        "InstagramGalleriesService.getGalleryById is ready",
                        {
                            id,
                        }
                    );
                    this.instagramGalleriesStore.update(() => ({
                        gallery: v,
                    }));
                })
            );
    }
}

export default instagramGalleryService;
